export * from './validateTdcForm';
export * from './validatePagoMovilForm';
